var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"div-padding bg-content-white"},[_c('b-container',{staticClass:"pt-5 pb-5 wrapper"},[_c('b-row',{staticClass:"d-flex mt-5-custome justify-content-center"},[_c('b-row',{staticClass:"loading"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }